import { Injectable } from '@angular/core';
import {
	extractJadeArrayReturn,
	JadeArrayReturn,
	StaffMasterSearchDto,
	StaffSearch,
	Types,
} from '@siza-staff-care/shared/data';
import { map, Observable } from 'rxjs';
import { JadeService } from './jade.service';

export type SearchStatus = 'current' | 'terminated' | '';

@Injectable({
	providedIn: 'root',
})
export class SearchService {
	constructor(private jade: JadeService) {}

	/**
	 * Searches for staff by text (staff code, names)
	 * @param searchText
	 * @param bypassRestrict
	 * @returns
	 */
	searchStaffMulti(searchText: string, bypassRestrict = false): Observable<StaffMasterSearchDto[]> {
		const searchParams: Partial<StaffSearch> = {
			$type: Types.StaffSearch,
			search: searchText,
			bypassRestrict,
		};

		return this.jade
			.post<JadeArrayReturn<StaffMasterSearchDto>>({
				$type: Types.ApiControllerRequest,
				params: searchParams,
			})
			.pipe(map((result) => extractJadeArrayReturn(result)));
	}

	/**
	 * Searches for staff by text (staff code, names), with various options.
	 * @param searchText
	 * @param opts
	 * @returns
	 */
	searchStaff(
		searchText: string,
		opts: {
			bankStaff?: boolean;
			excludeStaffWithNoCurrentContract?: boolean;
			status?: SearchStatus;
			filterTeams?: boolean;
		},
	): Observable<StaffMasterSearchDto[]> {
		const searchParams: Partial<StaffSearch> = {
			$type: Types.StaffSearch,
			bank: !!opts.bankStaff,
			search: searchText,
			excludeStaffWithNoCurrentContract: !!opts.excludeStaffWithNoCurrentContract,
			status: opts.status || '',
			filterTeams: !!opts.filterTeams,
		};

		return this.jade
			.post<JadeArrayReturn<StaffMasterSearchDto>>({
				$type: Types.ApiControllerRequest,
				params: searchParams,
			})
			.pipe(map((result) => extractJadeArrayReturn(result)));
	}

	/**
	 * Gets the staff details for the given StaffMaster oid.
	 * @param oid
	 * @returns
	 */
	getStaffDetails(oid: string): Observable<StaffMasterSearchDto> {
		const searchParams: Partial<StaffSearch> = {
			$type: Types.StaffSearch,
			oid,
		};

		return this.jade
			.post<JadeArrayReturn<StaffMasterSearchDto>>({
				$type: Types.ApiControllerRequest,
				params: searchParams,
			})
			.pipe(
				map((result) => extractJadeArrayReturn<StaffMasterSearchDto>(result)),
				map((values) => values[0]),
			);
	}
}
